// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"68f0a23a","455":"4e1b8076","977":"c7c85ca3"}[chunkId] + ".chunk.js";
};